import { useQueryClient } from '@tanstack/react-query';

import { getAccountLegalEntity } from '@/shared/api/account';
import { getAuthSettings } from '@/shared/api/auth';
import { useAppQuery } from '@/shared/lib/useAppQuery';

const ACCOUNT_QUERY_KEY = {
  BASE: 'account',
  SETTINGS: 'settings',
  LEGAL_ENTITY: 'legal-entity',
} as const;

export const useAccountSettings = (enabled?: boolean) => {
  const { data: accountSettings, ...other } = useAppQuery({
    queryKey: [ACCOUNT_QUERY_KEY.BASE, ACCOUNT_QUERY_KEY.SETTINGS],
    queryFn: getAuthSettings,
    enabled,
  });

  return { accountSettings, ...other };
};

export const useInvalidateAccountSettingsQuery = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [ACCOUNT_QUERY_KEY.BASE, ACCOUNT_QUERY_KEY.SETTINGS],
    });
};

export const useAccountLegalEntity = (enabled = true) => {
  const { data: legalEntity, ...other } = useAppQuery({
    queryKey: [ACCOUNT_QUERY_KEY.BASE, ACCOUNT_QUERY_KEY.LEGAL_ENTITY],
    queryFn: getAccountLegalEntity,
    enabled,
  });

  return { legalEntity, ...other };
};

export const useInvalidateAccountLegalEntityQuery = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [ACCOUNT_QUERY_KEY.BASE, ACCOUNT_QUERY_KEY.LEGAL_ENTITY],
    });
};
